export default "\tmutation signOut($refreshToken: String!) {\n\t\tsignOut(refreshToken: $refreshToken)\n\t}";